/** Safe localStorage helpers — storage may be unavailable (private mode, quota, blocked). */
export function readLocal<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeLocal(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignore */
  }
}

export function removeLocal(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

/** Form drafts survive reloads/crashes; they expire after a day. */
export interface Draft<T> {
  value: T;
  savedAt: number;
}
export function loadDraft<T>(key: string): T | null {
  const d = readLocal<Draft<T> | null>(`taskos.draft.${key}`, null);
  if (!d || Date.now() - d.savedAt > 86_400_000) return null;
  return d.value;
}
export function saveDraft<T>(key: string, value: T): void {
  writeLocal(`taskos.draft.${key}`, { value, savedAt: Date.now() });
}
export function clearDraft(key: string): void {
  removeLocal(`taskos.draft.${key}`);
}
